module.exports = __webpack_public_path__ + "assets/img/e2d9f7e7d6185ff1b13cb0b3578c27b6.png";